<template>
  <div class="d-flex justify-content-end">
    <div class="me-3">
      <Button v-if="activeStep > 1"
          @click.prevent="goPrev"
          btn-class="btn"
          type="cancel"
          :btn-text="$t('button.prev')"
      />
    </div>
    <div>
      <Button
          btn-class="btn btn-primary"
          v-if="activeStep < stepCount"
          @click.prevent="validateAndNextStep"
          :btn-text="$t('button.next')"
      />
    </div>
    <div>
      <Button
          btn-class="btn btn-primary"
          v-if="activeStep === stepCount"
          @click.prevent="submitData"
          :btn-text="$t('button.finalise')"
          :is-loading="processing"
      />
    </div>
  </div>
</template>

<script setup>

import Button from "@/components/Button.vue";
import {ref} from "vue";

const emits = defineEmits(['nextStep', 'handleFinish', 'prevStep'])

const props = defineProps({
  stepperId: { type: String },
  stepCount: { type: Number, required: true },
  activeStep: Number,
  processing: { type: Boolean, default: false },
})

const stepper = ref(props.stepperId)

const validateAndNextStep = () => {
  const currentStepForm = document.querySelector(".step-item.active form");
  if (currentStepForm && currentStepForm.checkValidity()) {
    stepper.value ? stepper.value?.nextStep : emits('nextStep')
  } else {
    currentStepForm.reportValidity();
  }
}

const submitData = () => {
  emits('handleFinish')
}

const goPrev = () => {
  emits('prevStep')
}

</script>

<style scoped>

</style>